import loanStore from "./loan/store";
import reportStore from "./report/store";
export default {
  namespaced: true,
  modules: {
    loan: loanStore,
    report: reportStore,
  },
};
